{
  "COMMON": {
    "MEETING_ANALYSIS": "Meeting Analysis",
    "SUMMARY": "Summary",
    "PARTICIPANTS": "Participants",
    "KEY_TAKEAWAYS": "Key Takeaways",
    "ACTION_ITEMS": "Action Items",
    "TIME": "Time",
    "DATE": "Date",
    "DURATION": "Duration",
    "GOOGLE_MEET": "Google Meet",
    "ZOOM": "Zoom",
    "MICROSOFT_TEAMS": "Microsoft Teams",
    "TRACKERS": "Trackers",
    "KEYWORD_TRACKERS": "Keyword trackers",
    "KEYWORDS": "Keywords",
    "TRANSCRIPT": "Transcript",
    "GUESTS": "Guests",
    "DETAILS": "Details",
    "CONTACTS": "Contacts",
    "SHARE": "Share",
    "CANCEL": "Cancel",
    "COPY_LINK": "Copy link",
    "SAVE": "Save",
    "PUBLIC": "Public",
    "OPEN": "Open",
    "RAVEN": "RAVEN",
    "INTERACTIVITY": "Interactivity",
    "SENTIMENT" : "Sentiment",
    "AI_INSIGHTS": "AI Insights",
    "OVERVIEW": "Overview",
    "TOPICS": "Topics",
    "COPIED": "Copied text to clipboard",
    "UNKNOWN": "Unknown",
    "HOST": "Host",
    "CREATOR": "Creator",
    "EDIT": "Edit",
    "VIEW": "View",
    "CHANGE_VISIBILITY": "Change visibility",
    "VISIBILITY": "Visibility",
    "MEETING_LINK": "Meeting link",
    "SOURCE": "Source",
    "SEARCH": "Search",
    "UPCOMING": "Upcoming",
    "PAST": "Past",
    "DESCRIPTION": "Description",
    "CLOSE": "Close",
    "ERROR": "Something went wrong, please try again.",
    "UNKNOWN_USER": "Unknown user"
  },
  "MEETING_DETAILS": {
    "MEETING_DETAILS": "Meeting details",
    "SENTIMENT_ANALYSIS": "Sentiment analysis",
    "SENTIMENT_SCORE": "Sentiment score",
    "MEETING_METRICS": "Meeting metrics",
    "MEETING_TITLE": "Meeting title",
    "SCHEDULED_ON": "Scheduled on",
    "RAVEN_SCORE": "RAVEN score",
    "ATTENDEES": "Attendees",
    "TEAM_MEMBERS": "Team members",
    "MEETING_NOT_FOUND": "Meeting not found",
    "MEETING_NOT_FOUND_DESCRIPTION": "Please verify the address and try again.",
    "PERMISSION_REQUIRED": "Permission required",
    "PERMISSION_REQUIRED_DESCRIPTION" : "You don't have permission to view this meeting. Contact someone who was invited to the meeting to request access.",
    "RECORDING": {
      "LOADING_ERROR": "Error loading recording, please try again."
    }
  },
  "TRANSCRIPT": {
    "TRANSCRIPT_NOT_AVAILABLE_TITLE": "Transcript not available",
    "TRANSCRIPT_NOT_AVAILABLE_DESCRIPTION_V2": "The transcript is not available for this meeting.",
    "DOWNLOAD_TRANSCRIPT": "Download transcript",
    "DOWNLOAD": "Download transcript",
    "COPY_TRANSCRIPT": "Copy transcript",
    "COPY_SUCCESS": "Transcript copied to clipboard",
    "COPY_ERROR": "Failed to copy transcript. Please try again.",
    "DOWNLOAD_WILL_START_SHORTLY": "Your download will start shortly",
    "TRY_AGAIN": "There was an error downloading the transcript. Please try again later."
  },
  "RECORDING": {
    "URL_COPIED": "Copied text to clipboard",
    "VIDEO_NOT_SUPPORTED": "Your browser does not support the video tag"
  },
  "CALLS": {
    "TITLE": "Calls"
  },
  "COPIED_SUCCESSFULLY": "Copied successfully to clipboard",
  "SCHEDULE_BOT": {
    "DESCRIPTION_V2": "Record a live meeting by sending the meeting notetaker to the meeting link. Make sure the meeting is active or scheduled to start in the next few minutes.",
    "MEETING_URL": "Meeting Link",
    "INPUT_HINT": "Applies to Google Meet or Microsoft Teams",
    "PLACEHOLDER": "https://example.com/your-meeting-id",
    "SEND_NOW": "Start recording",
    "SUCCESS_V2": "The meeting notetaker has been scheduled to join the meeting as soon as possible.",
    "ERROR": "There was an error scheduling the meeting notetaker. Please try again.",
    "JOIN_MEETING_V2": "Record a live meeting",
    "URL_INVALID": "Please enter a valid meeting link"
  },
  "SHARE": {
    "TITLE": "Share meeting details",
    "DESCRIPTION": "Anyone at your organization can view this page.",
    "AT_CURRENT_TIME": "Start video at ",
    "AT_BEGINNING": "Start video at the beginning"
  },
  "CHANGE_VISIBILITY": {
    "TITLE": "Change visibility"
  },
  "SALES_COACH_CONFIG": {
    "MEETING_SETTINGS": "Meeting recording settings",
    "CALENDAR_CONNECTION_CARD": {
      "TITLE": "Your calendar connection",
      "DESCRIPTION": "Each member of your team will need to connect their own Google Meet account",
      "ACTION_V2": "Manage my connection"
    },
    "FORM": {
      "TITLE": "Meeting recording",
      "DESCRIPTION_V2": "The meeting notetaker will automatically join, record, and transcribe meetings in the connected calendars. Make sure meeting recording is enabled for your account.",
      "ACTION": "Review my meeting settings"
    },
    "MODAL": {
      "TITLE": "Save meeting recording settings?",
      "DESCRIPTION": "These settings can only be updated once per hour."
    },
    "ERROR_LOADING_CONFIG": "Error loading configuration, please try again.",
    "ERROR_SAVING_CONFIG": "Error saving configuration, please try again.",
    "CONFIG_SAVED": "Configuration saved successfully."
  },
  "ACTION_ITEMS_FOR": "Action items for",
  "INSIGHTS": {
    "SENTIMENT_SCORE": "Sentiment Score",
    "PATIENCE": "Patience",
    "INTERACTIVITY_SCORE": "Interactivity score",
    "SPEAKER_TALK_TIME": "Speaker talk time",
    "KEYWORDS": "Keywords",
    "CLARITY_REPORT": {
      "TITLE": "Clarity report",
      "PRONUNCIATION_AND_PACE": "Pronunciation and pace score:",
      "LANGUAGE_AND_SIMPLICITY": "Language and simplicity score:",
      "STRUCTURE_AND_ORGANIZATION": "Structure and organization score:",
      "ACTIVE_LISTENING": "Active listening score:",
      "LIMITED_FILLERS": "Limited fillers score:",
      "OBJECTION_HANDLING": "Objection handling score:",
      "TOTAL_SCORE": "Total score:"
    },
    "RECOMMENDATIONS": "Recommendations",
    "HIGHLIGHTS": "Highlights",
    "LOWLIGHTS": "Lowlights",
    "PAIN_POINTS": "Pain points",
    "SELLING_OPPORTUNITIES": "Selling opportunities",
    "SCORE_REASONING": "Score reasoning",
    "RAVEN": {
      "TITLE": "RAVEN score",
      "RAPPORT_AND_CONTEXT": "Rapport and context:",
      "ASSESSMENT_AND_DISCOVERY": "Assessment and discovery:",
      "VALUE_DELIVERY": "Value delivery:",
      "ENGAGEMENT_AND_OBJECTION_HANDLING": "Engagement and objection handling:",
      "NEXT_STEPS_AND_OWNERSHIP": "Next steps and ownership:"
    },
    "BANT": {
      "TITLE": "BANT score",
      "BUDGET_SCORE": "Budget score:",
      "AUTHORITY_SCORE": "Authority score:",
      "NEED_SCORE": "Need score:",
      "TIMELINE_SCORE": "Timeline score:"
    },
    "MEDPICC_SCORE": {
      "TITLE": "MEDDPICC score",
      "METRICS_SCORE": "Metrics score:",
      "ECONOMIC_BUYER_SCORE": "Economic buyer score:",
      "DECISION_CRITERIA_SCORE": "Decision criteria score:",
      "DECISION_PROCESS_SCORE": "Decision process score:",
      "PAPER_SCORE": "Paper score:",
      "IDENTIFY_PAIN_SCORE": "Identify pain score:",
      "CHAMPION_SCORE": "Champion score:",
      "COMPETITION_SCORE": "Competition score:"
    },
    "SANDLER_SCORE": {
      "TITLE": "Sandler score",
      "BONDING_AND_RAPPORT_SCORE": "Bonding and rapport score:",
      "UPFRONT_CONTRACT_SCORE": "Upfront contract score:",
      "PAIN_SCORE": "Pain score:",
      "BUDGET_SCORE": "Budget score:",
      "DECISION_SCORE": "Decision score:",
      "FULFILLMENT_SCORE": "Fulfillment score:",
      "POST_SELL_SCORE": "Post sell score:"
    },
    "SOLUTION_SELLING_SCORE": {
      "TITLE": "Solution Selling score",
      "SITUATION_KNOWLEDGE": "Situation knowledge:",
      "CAPABILITY_KNOWLEDGE": "Capability knowledge:",
      "PEOPLE_SKILLS": "People skills:",
      "SELLING_SKILLS": "Selling skills:"
    }
  },
  "VISIBILITY": {
    "OPEN": "All of {{ namespaceName }}",
    "NAMESPACE_NAME_FALLBACK": "your organization",
    "PRIVATE": "Private",
    "UNLISTED_V2": "Anyone in {{ namespaceName }} with the link",
    "MEETING_VISIBILITY_V2": "Visibility",
    "VISIBILITY_DESCRIPTION": {
      "PRIVATE": "Only meeting invitees in {{ namespaceName }} can view the meeting",
      "UNLISTED": "Anyone in {{ namespaceName }} with the link can view the meeting. The meeting will not appear in the CRM.",
      "OPEN": "Anyone in {{ namespaceName }} can view the meeting. An activity for the meeting will be logged in the CRM."
    },
    "ERROR_CHANGING": "There was an error changing the visibility, please try again.",
    "SUCCESS_CHANGING": "Successfully updated visibility"
  },
  "RECORDING_VISIBILITY": {
    "TITLE_V2": "Visibility",
    "OVERRIDE": "Set to private (override defaults)",
    "DEFAULT": "Use default settings",
    "UPDATED_BY": "Updated by {{ name }} on {{ date }}",
    "ERROR_OVERRIDING_PRIVACY": "There was an error overriding the recording privacy, please try again.",
    "DIALOG": {
      "TITLE_V2": "Visibility settings",
      "DESCRIPTION_V2": "The visibility determines who can view the meeting recording once it's completed. You can choose between two options for upcoming recordings:",
      "OPTION_1_TITLE": "Use default settings:",
      "OPTION_1_DESCRIPTION": "The visibility will be set after the meeting is completed based on the default settings of everyone invited to the meeting. If any guest has their default set to private, the meeting will be private for all guests.",
      "OPTION_2_TITLE": "Set to private (override defaults):",
      "OPTION_2_DESCRIPTION": "Forces the meeting to private for all guests, regardless of anyone's default settings.",
      "REVIEW_SETTINGS": "Review my default settings"
    },
    "OVERRIDE_DIALOG": {
      "TITLE": "Change visibility for upcoming recording",
      "DESCRIPTION": "The visibility determines who can view the meeting recording once it's completed."
    }
  },
  "MEETING_LIST": {
    "ERROR_LOADING_MEETINGS": "Error loading meetings, please try again.",
    "LOOKING_FOR_MORE": "Can't find the meeting you're looking for? Try the table view for more searching and filtering options.",
    "FILTER_NO_RESULTS": "Try adjusting or clearing your filters to see more bookings",
    "TABLE_FILTER_NO_RESULT": "Try the table view for more searching and filtering options",
    "NO_RESULTS": "No results found",
    "TABLE": {
      "COLUMNS": {
        "TITLE": "Meeting title",
        "DATE": "Date",
        "START_TIME": "Start time",
        "DURATION": "Duration",
        "GUESTS": "Guests",
        "VISIBILITY": "Visibility",
        "ACTIONS": "Actions",
        "URL": "Link/Location"
      },
      "FILTERS": {
        "KEYWORDS": "Keywords",
        "VISIBILITY": "Visibility",
        "MEETING_LINK": "Meeting link",
        "CONTACT": "Contact",
        "DATE": "Date"
      },
      "EDIT_VISIBILITY": "Edit visibility"
    }
  },
  "MEETING_ANALYSIS": {
    "EMPTY_STATE": {
      "PAST_TITLE": "No past recordings",
      "PAST_DESCRIPTION": "Recordings will appear here once they're completed",
      "UPCOMING_TITLE": "No upcoming recordings",
      "UPCOMING_DESCRIPTION": "Create a meeting in your calendar to schedule an upcoming recording"
    }
  },
  "VISIBILITY_INFO_DIALOG": {
    "TITLE": "Visibility settings",
    "INTRO": "The visibility determines who can view the meeting recording once it's completed. You can choose between three options for past recordings:",
    "PUBLIC_TITLE": "All of {{ namespaceName }}:",
    "PUBLIC_DESCRIPTION": "Anyone in {{ namespaceName }} can view the meeting. An activity for the meeting will be logged in the CRM.",
    "UNLISTED_TITLE": "Anyone in {{ namespaceName }} with the link:",
    "UNLISTED_DESCRIPTION": "Anyone in {{ namespaceName }} with the link can view the meeting. The meeting will not appear in the CRM.",
    "PRIVATE_TITLE": "Private:",
    "PRIVATE_DESCRIPTION": "Only meeting invitees in {{ namespaceName }} can view the meeting. The meeting will not appear in the CRM. "
  },
  "RECORDING_UPGRADE": {
    "TITLE": "Smarter meetings — stronger results",
    "DESCRIPTION": "From daily check-ins to high-stakes sales calls, Vendasta's AI-powered meeting recordings help you uncover insights, understand customer needs, and keep your pipeline moving—without extra effort.",
    "BENEFIT_1": "Save hours on note-taking",
    "BENEFIT_2": "Turn conversations into actionable insights",
    "BENEFIT_3": "Available on all paid Vendasta plans",
    "UPGRADE_PLAN": "Upgrade plan",
    "LEARN_MORE": "Learn more",
    "CONTACT_PREFIX": "Talk to sales",
    "OR_CALL_US": "or call us at"
  }
}
